/* eslint-disable  */
//@ts-nocheck

import React from 'react';

import ReactJson from 'react-json-view';
import Header from './Header';
import Spinner from './Spinner';
import StatusBar from './StatusBar';
import ajax from './ajax';
import { Typography } from '@mui/material';
import { PrimaryButton, SecondaryButton } from '@client/new/components/button';

const JSONFileEditor = ({
  configFileContent,
  onUpdate,
}: {
  configFileContent: unknown;
  onUpdate: (data: unknown) => void;
}) => {
  const onChange = (data) => {
    const content = data.updated_src;
    return onUpdate(content);
  };

  return (
    <ReactJson
      style={{
        padding: '20px',
      }}
      src={configFileContent}
      collapsed={false}
      name={'configFile'}
      theme="summerfruit:inverted"
      onEdit={onChange}
      onAdd={onChange}
      onDelete={onChange}
    />
  );
};

class ConfigFileEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      configFileContent: {},
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.fetchConfigFile = this.fetchConfigFile.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
    this.cancelChanges = this.cancelChanges.bind(this);
    this.mergeUpdatedConfigFile = this.mergeUpdatedConfigFile.bind(this);
    this.removeWholeJSON = this.removeWholeJSON.bind(this);
  }

  async componentDidMount() {
    await this.fetchConfigFile();
  }

  async fetchConfigFile() {
    try {
      this.setState({
        fetching: true,
      });
      const configlFile = await ajax.getConfigFile();
      this.setState({
        configFileContent: configlFile,
        fetching: false,
      });
    } catch (err) {
      this.setState({
        fetching: false,
      });
      StatusBar.sendErrorMessage(
        'Config file was not fetched, please try again.',
      );
    }
  }

  mergeUpdatedConfigFile(updatedConfigFile) {
    this.setState({
      configFileContent: updatedConfigFile,
    });
  }

  removeWholeJSON() {
    this.setState({
      configFileContent: {},
    });
  }

  async saveChanges() {
    try {
      this.setState({
        fetching: true,
      });
      const { configFileContent } = this.state;
      const updatedConfgilFile = await ajax.updateConfigFile(configFileContent);
      this.setState({
        configFileContent: updatedConfgilFile,
        fetching: false,
      });
    } catch (err) {
      this.setState({
        fetching: false,
      });
      StatusBar.sendErrorMessage(
        'Config file was not updated, please try again',
      );
    }
  }

  async cancelChanges() {
    try {
      this.setState({
        fetching: true,
      });
      await this.fetchConfigFile();
    } catch (err) {
      this.setState({
        fetching: false,
      });
      StatusBar.sendErrorMessage(
        'Config file was not fetched, please try again',
      );
    }
  }

  render() {
    const { fetching, configFileContent } = this.state;

    return (
      <div className="portalUserList">
        <Header>
          <Typography variant="h1">Config File Editor</Typography>
          <div className="flex flex-row gap-3">
            <div className="button-box">
              <PrimaryButton onClick={async () => await this.saveChanges()}>
                Save
              </PrimaryButton>
            </div>
            <div className="button-box">
              <SecondaryButton onClick={async () => await this.cancelChanges()}>
                Cancel
              </SecondaryButton>
            </div>
            <div className="button-box">
              <SecondaryButton
                onClick={async () => await this.removeWholeJSON()}
              >
                Reset JSON
              </SecondaryButton>
            </div>
          </div>
        </Header>
        <div className="workoutList">
          <main id="main">
            {fetching ? (
              <Spinner color={`#6367ef`} />
            ) : (
              <div>
                <JSONFileEditor
                  configFileContent={configFileContent}
                  onUpdate={(data) => {
                    return this.mergeUpdatedConfigFile(data);
                  }}
                />
              </div>
            )}
          </main>
        </div>
        <StatusBar.Component />
      </div>
    );
  }
}

export default ConfigFileEditor;
